import React from 'react'
import { EnterpriseDetail } from '../../../clients/kyousou_api_client'
import CheckIcon from '../../../images/check_icon.png'
import {
  QuillDisplay,
} from '../../../components/form/inputs/QuillEditor'

interface CoCreationTabProps {
  enterprise: EnterpriseDetail
}

const CoCreationTab: React.FC<CoCreationTabProps> = ({
  enterprise,
}) => {
  const coCreationInfo = enterprise.coCreationInfo

  if (!coCreationInfo) {
    return (
      <div className="text-center text-main-darkgray py-8">
        共創希望は登録されていません。
      </div>
    )
  }

  return (
    <div>
      <div className="pb-6">
        <h3 className="text-xl font-bold text-main-black mb-4">
          {coCreationInfo?.title}
        </h3>
        <QuillDisplay content={coCreationInfo.content || ''} />
      </div>

      {/* 区切り線 */}
      <div className="border-b border-black mb-6"></div>

      {/* 解決したい課題 */}
      {coCreationInfo?.issue && (
        <div className="pb-6">
          <h3 className="text-xl font-bold text-main-black mb-4">
            解決したい課題
          </h3>
          <QuillDisplay content={coCreationInfo.issue || ''} />
        </div>
      )}

      {/* 区切り線 */}
      {coCreationInfo?.issue &&
        (coCreationInfo?.goal || coCreationInfo?.requirement) && (
          <div className="border-b border-black mb-6"></div>
        )}

      {/* 共創で実現したいこと */}
      {coCreationInfo?.goal && (
        <div className="pb-6">
          <h3 className="text-xl font-bold text-main-black mb-4">
            共創で実現したいこと
          </h3>
          <QuillDisplay content={coCreationInfo.goal || ''} />
        </div>
      )}

      {/* 区切り線 */}
      {coCreationInfo?.goal && coCreationInfo?.requirement && (
        <div className="border-b border-black mb-6"></div>
      )}

      {/* 求めている条件 */}
      {coCreationInfo?.requirement && (
        <div className="pb-6">
          <div className="flex items-center mb-4">
            <img src={CheckIcon} alt="Check" className="w-7 h-7 mr-2" />
            <h3 className="text-xl font-bold text-main-black">
              求めている条件
            </h3>
          </div>
          <QuillDisplay content={coCreationInfo.requirement || ''} />
        </div>
      )}
    </div>
  )
}

export default CoCreationTab